import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CrossIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M7.99976,5.6572 L13.147456,0.509504 L15.410176,2.772224 L10.26248,7.91992 L15.490176,13.147616 L13.227456,15.410336 L7.99976,10.18264 L2.625808,15.556592 L0.363088,13.293872 L5.73704,7.91992 L0.443088,2.625968 L2.705808,0.363248 L7.99976,5.6572 Z'/> ]
  getViewBox = () => '0 0 16 16'
}
